module.exports = __webpack_public_path__ + "assets/img/d59eca1b09b5b596a57477338e362272.svg";